const MAX_VOLUME = 0.6;

export default class Musician {

    constructor() {
        this.idle = game.add.sound("space-1");
        this.dialogs = [
            game.add.sound("dialog-1"),
            game.add.sound("dialog-2"),
        ];
        this.playing = undefined;
    }

    playIdle() {
        if (this.playing) {
            this.playing.stop();
        }
        if (!this.idle.isPlaying) {
            this.idle.play(undefined, 0, MAX_VOLUME, true);
        } else {
            this.idle.volume = MAX_VOLUME;
        }
    }

    stop() {
        this.idle.stop();
        if (this.playing) {
            this.playing.stop();
        }
    }

    playDialog() {
        this.play(game.rnd.pick(this.dialogs));
    }

    play(sound) {
        if (this.playing === sound) return;
        if (this.playing) this.playing.stop();
        this.idle.volume = 0;
        this.playing = sound;
        sound.play(undefined, 0, MAX_VOLUME, true);
    }


}


// WEBPACK FOOTER //
// ./src/states/musician.js